<template>
    <div class="container">
        <MercenaryHeader :title="'스카우트 현황'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div class="btn_tab_container_wrapper">
            <div class="btn_tab_container">
                <div @click="setCurTab(CUR_TAB.RECEIVED_SUGGESTION)" :class="{ active: curTab === CUR_TAB.RECEIVED_SUGGESTION }" class="btn_tab_item">받은 제안</div>
                <div @click="setCurTab(CUR_TAB.VIEW_REQUEST)" :class="{ active: curTab === CUR_TAB.VIEW_REQUEST }" class="btn_tab_item">입단 요청서 조회</div>
                <div @click="setCurTab(CUR_TAB.REQUEST_REPORT)" :class="{ active: curTab === CUR_TAB.REQUEST_REPORT }" class="btn_tab_item">요청서 리포트</div>
            </div>
        </div>
        <template v-if="curTab === CUR_TAB.RECEIVED_SUGGESTION">
            <div v-if="showContents" class="content_container">
                <template v-if="scoutSuggestionList.length === 0">
                    <div class="empty_container">
                        <div class="common_circle blue">
                            <img style="width: 25px;" :src="require('@/assets/img/suggest.png')" alt="">
                        </div>
                        <div class="empty_text">아직 도착한 제안이 없어요.</div>
                        <div class="empty_text_description">
                            감독님들이 회원님을 발견하지 못했나 봐요.<br>가만히 기다리기보다 
                            <span style="font-weight: 700; color: #1170FF;">먼저 제안하는 건 어때요?</span>
                        </div>
                        <div @click="goToSendRequestListPage" class="common_margin">
                            <div class="suggest_container">
                                <div class="suggest_container_image">
                                    <img style="width: 52px;" :src="require('@/assets/img/send_suggest.png')" alt="">
                                </div>
                                <div class="suggest_container_title">적극 추천</div>
                                <div class="suggest_container_description">감독님께 먼저 제안 보내기</div>
                                <div class="suggest_container_description_2">원하는 구단에 내 입단 요청서를 직접 전달해 보세요</div>
                                <div class="suggest_container_button">바로가기 →</div>
                            </div>
                        </div>
                        <div v-if="isSoccerHowJoinWritten" @click="goToModifyRequestPage" class="common_white_btn">
                            <img style="width: 16px;" :src="require('@/assets/img/modify_request.png')" alt="">
                            <div>입단 요청서 수정하기</div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div style="margin-top: 14px;">
                        <div style="font-weight: 700; font-size: 14px;">총 <span style="font-weight: 700; color: var(--color-main);">{{ scoutSuggestionList.length }}건</span>의 제안이 도착했습니다.</div>
                        <div style="margin-top: 20px;" v-for="each, i in scoutSuggestionList" :key="i + 'scout_suggestion'">
                            <div v-if="each.from_member.team" class="team_container">
                                <div class="team_image">
                                    <img style="width: 28px;" :src="$resourcePath + each.from_member.team.image_path" alt="">
                                </div>
                                <div class="team_info">
                                    <div class="team_info_title">{{ each.from_member.team.name }}</div>
                                    <div class="team_info_sub">
                                        <div class="common_sub_info">
                                            <img style="width: 10px;" :src="require('@/assets/img/coach_img.png')" alt="">
                                            <div class="common_sub_info_text">{{ each.from_member.name }} 감독</div>
                                        </div>
                                        <div class="border_line"></div>
                                        <div class="common_sub_info_text">{{ each.from_member.team.place.name }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="contents_box">{{ each.contents }}</div>
                            <div class="button_row">
                                <button @click="showRejectConfirmPopup(each.idx, i, each.is_skip)" :class="each.is_skip == 0 ? '' : 'disabled'" class="heart_button">
                                    <img v-if="each.is_skip == 0" class="heart_icon" :src="require('@/assets/img/broken_heart.png')" alt="">
                                    <img v-else class="heart_icon" :src="require('@/assets/img/broken_heart_red.png')" alt="">
                                </button>
                                <button @click="showAcceptConfirmPopup(each.idx, i, each)" :class="each.is_skip == 0 ? '' : 'disabled'" class="send_interest_button">
                                    <span class="send_interest_text">수락하고 소통하기</span>
                                </button>
                            </div>
                            <div style="height: 1px; background: #210F031A; margin: 26px 0;"></div>
                        </div>
                    </div>
                </template>
            </div>
        </template>
        <template v-if="curTab === CUR_TAB.VIEW_REQUEST">
            <div v-if="showContents" class="content_container">
                <template v-if="viewRequestList.length === 0 && showContents">
                    <div class="empty_container">
                        <div class="common_circle orange">
                            <img style="width: 25px;" :src="require('@/assets/img/empty_request.png')" alt="">
                        </div>
                        <div class="empty_text">아직 조회한 감독님이 없어요.</div>
                        <div class="empty_text_description">
                            조금만 기다리면 감독님들이 찾아올 거예요!<br>기다리면서
                            <span style="font-weight: 700; color: var(--color-main);">훈련 영상을 업로드</span>
                            해보는 건 어때요?
                        </div>
                        <div class="common_margin">
                            <div @click="goToGroundPage" style="background-color: var(--color-main);" class="common_btn">훈련 영상 보러가기</div>
                            <div v-if="isSoccerHowJoinWritten" @click="goToModifyRequestPage" style="border: 1px solid #D9D9D9" class="common_white_btn">
                                <img style="width: 16px;" :src="require('@/assets/img/modify_request.png')" alt="">
                                <div>입단 요청서 수정하기</div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div style="margin-top: 14px;">
                        <div style="margin-bottom: 20px; font-weight: 700; font-size: 14px;"><span style="font-weight: 700; color: var(--color-main);">{{ viewRequestList.length }}명</span>의 감독님이 회원님의 입단 요청서를 조회했습니다</div>
                        <div :style="{ paddingTop: i === 0 ? '0' : '10px', borderTop: i === 0 ? 'none' : '1px solid #D9D9D980' }" v-for="each, i in viewRequestList" :key="i + 'view_request'" style="padding-bottom: 10px;" class="team_container">
                            <div v-if="each.team" class="team_image">
                                <img style="width: 28px;" :src="$resourcePath + each.team.image_path" alt="">
                            </div>
                            <div v-if="each.team" class="team_info">
                                <div class="team_info_title">{{ each.team.name }}</div>
                                <div class="team_info_sub">
                                    <div class="common_sub_info">
                                        <img style="width: 10px;" :src="require('@/assets/img/coach_img.png')" alt="">
                                        <div class="common_sub_info_text">{{ each.name }} 감독</div>
                                    </div>
                                    <div class="border_line"></div>
                                    <div class="common_sub_info_text">{{ each.team.place.name }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </template>
        <template v-if="curTab === CUR_TAB.REQUEST_REPORT">
            <div v-if="showContents" class="content_container">
                <template v-if="requestReportList.length === 0 && showContents">
                    <div class="empty_container">
                        <div class="common_circle green">
                            <img style="width: 25px;" :src="require('@/assets/img/empty_report.png')" alt="">
                        </div>
                        <div class="empty_text">보낸 다이렉트 요청서가 없습니다.</div>
                        <div class="empty_text_description">
                            가고 싶은 팀이 있다면<br>
                            <span style="font-weight: 700; color: #44A96C;">먼저 다이렉트 요청서를 보내보세요!</span>
                        </div>
                        <div @click="goToSendRequestListPage" class="common_margin">
                            <div class="suggest_container">
                                <div class="suggest_container_image">
                                    <img style="width: 52px;" :src="require('@/assets/img/send_suggest.png')" alt="">
                                </div>
                                <div class="suggest_container_title">적극 추천</div>
                                <div class="suggest_container_description">감독님께 먼저 제안 보내기</div>
                                <div class="suggest_container_description_2">원하는 구단에 내 입단 요청서를 직접 전달해 보세요</div>
                                <div class="suggest_container_button">바로가기 →</div>
                            </div>
                        </div>
                        <div @click="goToFindSoccerTeamPage" class="common_white_btn">
                            <img style="width: 16px;" :src="require('@/assets/img/find_soccer_team.png')" alt="">
                            <div>축구팀 찾기</div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div style="margin-top: 14px; font-size: 14px; color: #606060; margin-bottom: 20px;">눌러서 상세정보를 확인할 수 있습니다</div>
                    <div v-for="each, i in requestReportList" style="" :key="i">
                        <div style="display: flex; gap: 4px; align-items: center;">
                            <img style="width: 12px;" :src="require('@/assets/img/direct_message.png')" alt="">
                            <div style="font-weight: 500; line-height: 24px; margin-bottom: 4px;">{{ each.team ? each.team.name : '' }}, {{ each.to_member.nic_name }}</div>
                        </div>
                        <div style="display: flex; gap: 4px; align-items: center; margin-bottom: 16px;">
                            <img style="width: 8px;" :src="require('@/assets/img/check_gray.png')" alt="">
                            <div style="font-weight: 500; font-size: 14px; line-height: 24px; color: #808080;">요청서 전달됨</div>
                        </div>
                        <div v-if="each.soccerhow" style="background-color: #0000000D; border-radius: 12px; padding: 12px;">
                            <CommonPost :hideOption="true" :isReportList="true" :soccerHows="each.soccerhow"></CommonPost>
                        </div>
                        <div @click="showMyReport(each.soccerhow.idx, each.idx); $Util.sendEventClick('사커하우_요청서리포트_자세히보기')" style="margin-top: 16px; display: flex; gap: 4px; align-items: center;">
                            <img style="width: 20px;" :src="require('@/assets/img/show_report.png')" alt="">
                            <div style="font-weight: 700; font-size: 14px; line-height: 24px; color: var(--color-main);">요청서 리포트 보기</div>
                            <img style="width: 10px;" :src="require('@/assets/img/arrow_main_color.png')" alt="">
                        </div>
                        <div style="height: 1px; background: #210F031A; margin: 30px 0;"></div>
                    </div>
                </template>
            </div>
        </template>
        <CommonConfirmFrame :containerWidth="'calc(100% - 24px)'" v-if="isShowRejectConfirmPopup" :isShowConfirmPopup="isShowRejectConfirmPopup" :closeConfirmPopup="closeRejectConfirmPopup">
            <div v-if="rejectStep === REJECT_STEP.DEFAULT">
                <div style="background-color: #FEF0F0;" class="common_circle_small">
                    <img style="width: 20px;" :src="require('@/assets/img/broken_heart_red.png')" alt="" />
                </div>
                <div style="margin-top: 15px; text-align: center;">
                    <div style="font-weight: 700; font-size: 20px; line-height: 24px;">정말 거절하시겠습니까?</div>
                    <div style="font-weight: 600; font-size: 14px; line-height: 24px; color: #808080; margin-top: 5px;">
                        감독님이 회원님을 위해 보낸 제안입니다<br>
                        <span style="color: #E60000; font-weight: 700;">거절하면 되돌릴 수 없습니다</span>
                    </div>
                    <div style="margin-top: 25px;">
                        <div style="font-size: 12px; font-weight: 600; line-height: 18px; color: #808080;">아직 고민 중이시라면 잠시 보류해두는 건 어때요?<br>나중에 다시 결정할 수 있습니다</div>
                    </div>
                </div>
                <div class="btn_wrapper">
                    <div @click="rejectOrAcceptDierectMessage(false, selectedMessageIdx)" style="background-color: #fff; border: 1px solid #808080; width: 112px;" class="common_confirm_btn reject_btn">거절</div>
                    <div @click="closeRejectConfirmPopup" style="background-color: var(--color-main); color: #fff; flex: 1;" class="common_confirm_btn confirm">더 고민해볼게요</div>
                </div>
            </div>
            <div v-else-if="rejectStep === REJECT_STEP.REJECTED">
                <div class="common_circle_small" style="background-color: #FF000033;">
                    <img style="width: 16px" :src="require('@/assets/img/exclamation_mark.png')" alt="">
                </div>
                <div style="margin-top: 15px; text-align: center;">
                    <div style="font-weight: 700; font-size: 20px; line-height: 24px;">이미 거절한 제안입니다.</div>
                    <div style="font-weight: 500; font-size: 14px; line-height: 24px; color: #808080; margin-top: 10px;">
                        아쉽게도 거절 처리가 완료되어,<br>해당 제안과 관련한 추가 활동은 어렵습니다.
                    </div>
                    <div @click="closeRejectConfirmPopup" class="common_confirm_btn" style="background-color: #210f03; margin: 0 auto; margin-top: 20px; color: #fff; width: 195px;">확인</div>
                </div>
            </div>
        </CommonConfirmFrame>
        <CommonConfirmFrame :containerWidth="'calc(100% - 24px)'" v-if="isShowAcceptConfirmPopup" :isShowConfirmPopup="isShowAcceptConfirmPopup" :closeConfirmPopup="closeAcceptConfirmPopup">
            <div v-if="acceptStep === ACCEPT_STEP.DEFAULT">
                <div class="common_circle_small" style="background-color: #FF711133;">
                    <img style="width: 16px" :src="require('@/assets/img/letter.png')" alt="">
                </div>
                <div style="margin-top: 15px; text-align: center;">
                    <div style="font-weight: 700; font-size: 20px; line-height: 24px;">테스트 제안을 수락하시겠습니까?</div>
                    <div style="font-weight: 500; font-size: 14px; line-height: 24px; color: #808080; margin-top: 10px;">
                        <span style="color: var(--color-main);">{{ matchingInfo.teamName }}</span>의 제안을 수락합니다.<br>수락 시 감독님과 1:1 대화방이 즉시 개설됩니다.
                    </div>
                </div>
                <div style="margin-top: 20px;" class="btn_wrapper">
                    <div @click="closeAcceptConfirmPopup" style="background-color: #fff; border: 1px solid #808080; width: 112px;" class="common_confirm_btn reject_btn">고민할게요</div>
                    <div @click="rejectOrAcceptDierectMessage(true, selectedAcceptMessageIdx)" style="background-color: #111725; color: #fff; flex: 1;" class="common_confirm_btn confirm">수락하기</div>
                </div>
            </div>
            <div v-else-if="acceptStep === ACCEPT_STEP.ACCEPTED">
                <div class="common_circle_small" style="background-color: #FF711133;">
                    <img style="width: 16px" :src="require('@/assets/img/letter.png')" alt="">
                </div>
                <div style="margin-top: 15px; text-align: center;">
                    <div style="font-weight: 700; font-size: 20px; line-height: 24px;">매칭이 성사되었습니다! 🎉</div>
                    <div style="font-weight: 500; font-size: 14px; line-height: 24px; color: #808080; margin-top: 5px;">
                        <span style="color: var(--color-main);">{{ matchingInfo.teamName }}감독님</span>과 연결되었습니다.<br>감독님과 소통을 시작해보세요
                    </div>
                </div>
                <div class="profile_connection">
                    <div class="profile_section">
                        <div class="profile_image_wrapper">
                            <ProfileImage 
                                :imagePath="$GlobalStore.loginInfo().image_path" 
                            />
                        </div>
                        <div class="profile_name_row">
                            <span class="profile_name">{{ $GlobalStore.loginInfo().nic_name }}</span>
                            <span class="position_text">{{ $GlobalStore.loginInfo().position }}</span>
                        </div>
                    </div>
                    <div class="connection_dots">
                        <span v-for="i in 5" :key="i" class="dot"></span>
                    </div>
                    <div class="profile_section">
                        <div class="profile_image_wrapper">
                            <ProfileImage 
                                :imagePath="matchingInfo.coachImage" 
                            />
                        </div>
                        <div class="profile_name_row">
                            <span class="profile_name">{{ matchingInfo.coachName }}</span>
                            <img  class="star_icon" :src="require('@/assets/img/coach_star_yellow.png')" alt="" />
                        </div>
                    </div>
                </div>
                <div style="margin-top: 0;" class="btn_wrapper">
                    <div @click="closeAcceptConfirmPopup" style="background-color: #fff; border: 1px solid #808080; width: 112px;" class="common_confirm_btn reject_btn">나중에 하기</div>
                    <div @click="sendDirectMessage" style="background-color: #111725; color: #fff; flex: 1;" class="common_confirm_btn confirm">메세지 보내기</div>
                </div>
            </div>
        </CommonConfirmFrame>
        <MakeRequestJoinForm 
            :isShowMakeRequestJoinForm="isShowMakeRequestJoinForm" 
            :isFromReportList="true" 
            :soccerhowIdx="soccerhowIdx"
            :closeRequestJoinForm="closeRequestJoinForm">
        </MakeRequestJoinForm>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import ResponseCode from '@/ResponseCode'
import CommonPost from '@/components/soccerhowmain/CommonPost'
import CommonConfirmFrame from '@/components/common/CommonConfirmFrame'
import ProfileImage from '@/components/common/ProfileImage'
import { FORM_MODE } from '@/Constants'
import MakeRequestJoinForm from '@/components/soccerhowmain/MakeRequestJoinForm'

const CUR_TAB = {
    RECEIVED_SUGGESTION: 0,
    VIEW_REQUEST: 1,
    REQUEST_REPORT: 2,
}

const REJECT_STEP = {
    DEFAULT: 1,
    REJECTED: 2,
}

const ACCEPT_STEP = {
    DEFAULT: 1,
    ACCEPTED: 2,
}
export default {
    name: 'CurrentScoutUser',
    components: { MercenaryHeader, CommonPost, CommonConfirmFrame, ProfileImage, MakeRequestJoinForm },
    data() {
        return {
            isShowMakeRequestJoinForm: false,
            FORM_MODE: FORM_MODE,
            CUR_TAB: CUR_TAB,
            curTab: CUR_TAB.RECEIVED_SUGGESTION,
            scoutSuggestionList: [],
            viewRequestList: [],
            requestReportList: [],
            showContents: false,
            isShowRejectConfirmPopup: false,
            selectedMessageIdx: null,
            selectedMessageIndex: null,
            rejectStep: REJECT_STEP.DEFAULT,
            REJECT_STEP: REJECT_STEP,
            isShowAcceptConfirmPopup: false,
            selectedAcceptMessageIdx: null,
            selectedAcceptMessageIndex: null,
            acceptStep: ACCEPT_STEP.DEFAULT,
            ACCEPT_STEP: ACCEPT_STEP,
            matchingInfo: {
                teamName: '',
                coachImage: '',
                coachName: '',
            },
            isSoccerHowJoinWritten: false,
            requestReportCount: null,
            soccerhowIdx: null,
        }
    },
    created() {
        this.getMyCurrentScout(this.curTab)
        this.checkIsSoccerHowJoinWritten()
    },
    methods: {
        closeRequestJoinForm() {
            this.isShowMakeRequestJoinForm = false
        },
        showMakeRequestJoinForm() {
            this.isShowMakeRequestJoinForm = true
        },
        goToSendRequestListPage() {
            if (this.requestReportCount === 0) {
                this.$GlobalStore.addModal('SelectPlayerType')
            } else if (this.requestReportCount === 1) {
                this.showMakeRequestJoinForm()
            } else {
                this.$GlobalStore.addModal('SendRequestList')
            }
        },
        async checkIsSoccerHowJoinWritten() {
            const parameters = {}
            parameters.need_only_one = true
            const res = await this.$Axios.get('/api/soccerhow/check/join/written', { params: parameters })
            if (res.data.code === ResponseCode.SUCCESS) {
                const { isSoccerHowJoinWritten, soccerhowIdx, isJoinOnlyOneWritten } = res.data
                    this.isSoccerHowJoinWritten = isSoccerHowJoinWritten
                    this.soccerhowIdx = soccerhowIdx
                    this.isJoinOnlyOneWritten = isJoinOnlyOneWritten
            }
        },
        goToModifyRequestPage() {
            // 입단 요청서를 작성한 경우
            if (this.isSoccerHowJoinWritten) {
                // 작성한 입단요청서가 하나만 있는경우
                if (this.isJoinOnlyOneWritten) {
                    this.$GlobalStore.addModal('WriteDefaultInfoForm', { soccerhowIdx: this.soccerhowIdx, mode: FORM_MODE.UPDATE });
                // 작성한 입단요청서가 여러개인경우
                } else {
                    this.$GlobalStore.addModal('ModifyRequestList')
                }
            }

        },
        goToFindSoccerTeamPage() {
            this.$GlobalStore.closeModalAll()
            this.$router.push({ path: '/view/soccer_join' + '?time=&isFromHome=true' + new Date().getTime(), props: { data: { mode: 'page' } } });
        },
        goToGroundPage() {
            this.$GlobalStore.closeModalAll()
            this.$router.push({ path: '/view/soccer_learn' + '?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
        },
        setCurTab(tab) {
            this.showContents = false
            this.curTab = tab
            this.getMyCurrentScout(tab)
        },
        async getMyCurrentScout(type) {
            const parameters = {}
            parameters.is_detail = true
            parameters.type = type
            if (type === CUR_TAB.REQUEST_REPORT || type === CUR_TAB.RECEIVED_SUGGESTION) {
                parameters.need_request_report_count = true
            }
            const res = await this.$Axios.get('/api/member/scouting/my_current', { params: parameters })
            if (res.data.code === ResponseCode.SUCCESS) {
                this.scoutSuggestionList = res.data.received_suggestion_list
                this.viewRequestList = res.data.view_request_list
                this.requestReportList = res.data.request_report_list
                this.requestReportCount = res.data.request_report_count
                if (this.requestReportCount === 1) {
                    this.soccerhowIdx = res.data.my_request_report.idx
                }
                this.showContents = true
            }
        },
        showMyReport(idx, direct_message_idx) {
            this.$GlobalStore.addModal('RequestReportDetail', { soccerhowIdx: idx, direct_message_idx: direct_message_idx })
        },
        async rejectOrAcceptDierectMessage(is_accepted, messageIdx) {
            const formData = new FormData()
            formData.append('is_accepted', is_accepted)
            formData.append('direct_message_idx', messageIdx)

            const res = await this.$Axios.post('/api/direct_message/change/status', formData)

            if (res.data.code === 0) {
                if (!is_accepted) {
                    this.$set(this.scoutSuggestionList[this.selectedMessageIndex], 'is_skip', 1)
                    this.closeRejectConfirmPopup()
                } else {
                    this.$delete(this.scoutSuggestionList, this.selectedAcceptMessageIndex)
                    this.acceptStep = ACCEPT_STEP.ACCEPTED
                }
                this.chatIdx = res.data.chat_idx
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        showRejectConfirmPopup(messageIdx, index, is_skip) {
            if (is_skip == 1) {
                this.rejectStep = REJECT_STEP.REJECTED
                this.isShowRejectConfirmPopup = true
                return
            }
            this.selectedMessageIdx = messageIdx
            this.isShowRejectConfirmPopup = true
            this.selectedMessageIndex = index
        },
        closeRejectConfirmPopup() {
            this.rejectStep = REJECT_STEP.DEFAULT
            this.selectedMessageIndex = null
            this.selectedMessageIdx = null
            this.isShowRejectConfirmPopup = false
        },
        showAcceptConfirmPopup(messageIdx, index, teamInfo) {
            this.selectedAcceptMessageIdx = messageIdx
            this.selectedAcceptMessageIndex = index
            if (teamInfo.is_skip == 1) {
                this.rejectStep = REJECT_STEP.REJECTED
                this.isShowRejectConfirmPopup = true
            } else {
                this.acceptStep = ACCEPT_STEP.DEFAULT
                this.isShowAcceptConfirmPopup = true
            }
            this.matchingInfo.teamName = teamInfo.from_member.team.name
            this.matchingInfo.coachImage = teamInfo.from_member.image_path
            this.matchingInfo.coachName = teamInfo.from_member.name
        },
        closeAcceptConfirmPopup() {
            this.acceptStep = ACCEPT_STEP.DEFAULT
            this.selectedAcceptMessageIndex = null
            this.selectedAcceptMessageIdx = null
            this.isShowAcceptConfirmPopup = false
        },
        async sendDirectMessage() {
            await this.$Axios.showChattingBySoccerJoinIdx(this.chatIdx);
            this.closeAcceptConfirmPopup()
        },
    }
}
</script>

<style scoped>
.btn_tab_container_wrapper {
    padding: 0 12px;
    padding-bottom: 14px;
}

.btn_tab_container {
    display: flex;
    background: #0000000D;
    border-radius: 12px;
    padding: 5px;
}

.btn_tab_item {
    flex: 1;
    text-align: center;
    padding: 4px;
    line-height: 24px;
    font-size: 12px;
    font-weight: 700;
    border-radius: 10px;
    color: #797979;
}

.btn_tab_item.active {
    background: #fff;
    color: #210f03;
}

.content_container {
    flex: 1;
    overflow-y: auto;
    padding: 0 24px;
}

.empty_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 84px;
}

.common_circle {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.blue {
    background-color: #1170FF1A;
}

.orange {
    background-color: #FF71111A;
}

.green {
    background-color: #44A96C1A;
}

.empty_text {
    margin-top: 25px;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
}

.empty_text_description {
    margin-top: 10px;
    color: #808080;
    line-height: 24px;
    font-weight: 500;
    text-align: center;
}

.common_margin {
    margin-top: 50px;
    width: 100%;
}

.suggest_container {
    box-shadow: 0px 2px 10px 0px #0000001A;
    background-color: #111725;
    border-radius: 12px;
    padding: 12px 0;
    padding-left: 24px;
    color: #fff;
    position: relative;
    width: 100%;
}

.suggest_container_image {
    position: absolute;
    top: 9px;
    right: 18px
}

.suggest_container_title {
    padding: 2px 6px;
    line-height: 16px;
    font-size: 12px;
    font-weight: 800;
    background-color: var(--color-main);
    border-radius: 4px;
    display: inline-block;
}

.suggest_container_description {
    margin-top: 5px;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
}

.suggest_container_description_2 {
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
}

.suggest_container_button {
    margin-top: 10px;
    font-weight: 700;
    font-size: 12px;
    line-height: 24px;
    color: var(--color-main);
}

.common_white_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    box-shadow: 0px 2px 10px 0px #0000001A;
    backdrop-filter: blur(20px);
    border-radius: 12px;
    margin-top: 20px;
    gap: 10px;
    color: #808080;
    font-weight: 900;
    width: 100%;
}

.common_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    border-radius: 12px;
    box-shadow: 0px 2px 10px 0px #210F031A;
    color: #fff;
    font-weight: 900;
}

.team_container {
    display: flex;
    align-items: center;
    gap: 17px;
}

.team_info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-weight: 500;
}

.team_info_title {
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
}

.team_info_sub {
    display: flex;
    gap: 7px;
    align-items: center;
    color: #808080;
    font-size: 12px;
}

.common_sub_info {
    display: flex;
    align-items: center;
    gap: 4px;
}

.border_line {
    width: 1px;
    height: 10px;
    background-color: #808080;
}

.common_sub_info_text {
    line-height: 24px;
}

.contents_box {
    background-color: #0000000D;
    padding: 10px;
    font-size: 12px;
    line-height: 20px;
    font-weight: 500;
    border-radius: 12px;
    margin-top: 20px;
}

.button_row {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-top: 20px;
}

.heart_button {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background-color: #E0E0E0;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
}

.disabled {
    background-color: #210f03;
}

.heart_icon {
    width: 20px;
}

.send_interest_button {
    flex: 1;
    height: 48px;
    border-radius: 12px;
    background-color: #210F03;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    cursor: pointer;
    color: var(--color-main);
}

.send_interest_button.disabled {
    background-color: #d9d9d9;
    color: #808080;
}

.send_interest_text {
    font-size: 14px;
    font-weight: 700;
}

.common_circle_small {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}

.common_confirm_btn {
    padding: 14px 0;
    line-height: 18px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
}

.btn_wrapper {
    margin-top: 40px;
    display: flex;
    gap: 18px;
}

.profile_connection {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding: 20px 0;
}

.profile_section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.profile_image_wrapper {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    overflow: hidden;
}

.profile_image_wrapper img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.profile_name_row {
    display: flex;
    align-items: center;
    gap: 4px;
    justify-content: center;
}

.profile_name {
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: #000;
}

.star_icon {
    width: 13px;
}

.position_text {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #FF7111;  /* 주황색 CM */
}

.connection_dots {
    display: flex;
    gap: 6px;
    align-items: center;
    margin-bottom: 26px;
}

.dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #D9D9D9;
}
</style>